import type {PopupRef} from '../UI/overlays/Popup.js'

/**
 * Tells that the account requires two-factor authentication but has none set up yet, with an Uitloggen action: it is
 * set up while logging in. onLogout is the LoginActions.logout of the app (the planner and the courier app each have
 * their own).
 */
export default function showTwoFactorWarning(popup: PopupRef, onLogout: () => void) {
    return popup.openAlert(
        'Tweestapsverificatie nog niet ingesteld.',
        'Er is nog geen tweestapsverificatie ingesteld op dit account, maar het is wel verplicht. Log uit en vervolgens weer in op het betreffende account om het proces voor het instellen van tweestapsverificatie te starten.',
        {actionLabel: 'Uitloggen', onAction: onLogout}
    )
}
